// extracted by mini-css-extract-plugin
module.exports = {"testReportContainer":"styles__testReportContainer--1TFMU","tableParent":"styles__tableParent--6jL4G"};